import api, { adminApiPrefix } from './Api';
import {
  RefundFilter,
  refundFilterToParams,
} from '../interfaces/Refund/RefundFilter';
import { PaginatedResponse } from '../interfaces/PaginatedResponse';
import { Refund, refundFromResponse } from '../interfaces/Refund/Refund';
import { RefundStatus } from '../interfaces/Refund/RefundStatus';

const refundAdminApiPrefix = `${adminApiPrefix}/refunds`;

export const getRefunds = async (
  filter: RefundFilter,
): Promise<PaginatedResponse<Refund>> => {
  const response = await api.get(refundAdminApiPrefix, {
    params: refundFilterToParams(filter),
  });

  return {
    data: (response.data?.data ?? []).map((refund: any) =>
      refundFromResponse(refund),
    ),
    totalCount: response.data?.total_count ?? 0,
  };
};

export const getRefund = async (id: number): Promise<Refund> => {
  const response = await api.get(`${refundAdminApiPrefix}/${id}`);

  return refundFromResponse(response.data?.data);
};

export const updateRefundStatus = async (
  id: number,
  refundStatus: RefundStatus,
): Promise<void> =>
  api.patch(`${refundAdminApiPrefix}/${id}`, { status: refundStatus });
